import * as React from 'react';
import { IItemsViewLayoutHandler, itemsViewLayoutHandlerControl, IItemsViewLayoutProps } from '../../../controls/itemsViewBetaControl';
import { Facet } from '../../../models/Facet';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { withPageLoadTracker } from '../../decorators/withPageLoadTracker';
import { errorFacet } from '../../../facets/DemandFacets';
import { ItemError } from '../../itemsError/ItemError';

const PageLoadItemError = withPageLoadTracker([errorFacet])(ItemError);

class LayoutItemError extends React.PureComponent<IItemsViewLayoutProps> {
  public render(): JSX.Element | null {
    const {
      itemKey
    } = this.props;

    return itemKey ? (
      <PageLoadItemError itemKey={ itemKey } />
    ) : null;
  }
}

export const itemsViewErrorLayoutHandler: IItemsViewLayoutHandler = {
  key: new Facet('itemsViewErrorLayout').id,
  command: {}, // This layout should not appear as a command.
  controlHandler: (
    itemCache: IItemCache,
    props: typeof itemsViewLayoutHandlerControl.inputType
  ): typeof itemsViewLayoutHandlerControl.returnType => {
    const {
      itemKey
    } = props;

    const isError = itemCache.isItemFacetResolved(errorFacet, itemKey);

    const error = isError ? itemCache.demandItemFacet(errorFacet, itemKey) : undefined;

    if (!error) {
      return {};
    }

    return {
      layout: LayoutItemError
    };
  }
};
